module.exports = __webpack_public_path__ + "static/media/word-excel.066a6f3b.svg";